import { render } from "./AccountSettingsOffice.vue?vue&type=template&id=31175b9a"
import script from "./AccountSettingsOffice.vue?vue&type=script&lang=js"
export * from "./AccountSettingsOffice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__